import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "text-lg text-center"
};
import { app } from "@/di";
import RichDialog from "@/modules/vue/components/RichDialog.vue";
import { DialogService } from "@/modules/vue/services/DialogService";
import { generateColorMap } from "@/modules/vue/utils";
export default /*#__PURE__*/_defineComponent({
  __name: 'Dialog',
  setup(__props) {
    const dialog = ref();
    const type = ref('info');
    const title = ref();
    const content = ref();
    const closable = ref(true);
    const icon = ref();
    const colorMap = generateColorMap({
      text: 300
    });
    const iconClass = computed(() => colorMap[{
      success: ColorEnum.Green,
      info: ColorEnum.Sky,
      error: ColorEnum.Red
    }[type.value]]);
    const show = props => {
      if (props.type) {
        type.value = props.type;
      }
      title.value = props.title;
      content.value = props.text;
      icon.value = props.icon;
      closable.value = typeof props.closable == 'boolean' ? props.closable : true;
      nextTick(() => dialog.value.show());
    };
    const hide = () => {
      nextTick(() => dialog.value.hide());
    };
    app.get(DialogService).init({
      show,
      hide
    });
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createBlock(RichDialog, {
        ref_key: "dialog",
        ref: dialog,
        "show-ok-only": closable.value,
        "hide-actions": !closable.value
      }, _createSlots({
        default: _withCtx(() => [icon.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["text-center mb-2", _unref(iconClass)])
        }, [_createVNode(_component_Icon, {
          icon: icon.value,
          size: "3rem"
        }, null, 8, ["icon"])], 2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, _toDisplayString(content.value), 1)]),
        _: 2
      }, [title.value ? {
        name: "title",
        fn: _withCtx(() => [_createTextVNode(_toDisplayString(title.value), 1)])
      } : undefined]), 1032, ["show-ok-only", "hide-actions"]);
    };
  }
});